import { UserAttributesClient } from 'frontend-preferences-client';
export const userAttributesClient = UserAttributesClient.forCaller('customer-data-properties');